import { ConfigType } from '../utils/requestAPI';

export type AddTemplateDataType = {
  templateTitle?: string;
  notes?: string;
  country?: string;
  uploadTemplate?: string[];
};
type ParamsType = {
  page?: number;
  limit?: number;
  search?: string;
};

const templateApi = {
  addTemplate: (data: AddTemplateDataType): ConfigType => {
    return {
      url: '/templates',
      method: 'post',
      data: data,
    };
  },

  getAllTemplate: (params: ParamsType): ConfigType => {
    return {
      url: '/templates',
      method: 'get',
      params,
      config: { store: { action: 'set', key: 'templates.data' } },
    };
  },
  getSingleTemplate: (id: string): ConfigType => {
    return {
      url: `/templates/${id}`,
      method: 'get',
      config: { store: { action: 'set', key: 'singleTemplateData' } },
    };
  },
};

export default templateApi;
